var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pagination-wrap"},[_c('el-pagination',{attrs:{"current-page":_vm.pageObj.currentPage,"page-sizes":_vm.pageObj.pageSizes,"page-size":_vm.pageObj.pageSize,"layout":"total, sizes, prev, pager, next, jumper","total":_vm.pageObj.total},on:{"size-change":_vm.handleSizeChange,"current-change":_vm.handleCurrentChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }